import { BaseMetadataSource } from './base-medatasource'

export enum BehaviourType {
  None,
  NumericOnly,
  OnlyLoggingEnabled,
}
export interface AllEntitiesMetadataSource extends BaseMetadataSource {
  excludeEntity: string
  fieldTenant: string
  behaviourType?: BehaviourType
}
